import { render, staticRenderFns } from "./Abouts.vue?vue&type=template&id=407d33e5&scoped=true"
import script from "./Abouts.vue?vue&type=script&lang=js"
export * from "./Abouts.vue?vue&type=script&lang=js"
import style0 from "./Abouts.vue?vue&type=style&index=0&id=407d33e5&prod&lang=less&scoped=true"
import style1 from "./Abouts.vue?vue&type=style&index=1&id=407d33e5&prod&lang=less"
import style2 from "./Abouts.vue?vue&type=style&index=2&id=407d33e5&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407d33e5",
  null
  
)

export default component.exports